module.exports = __webpack_public_path__ + "static/media/tope.e0ff6d81.mp4";